import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../hooks/useApi';

const FILTROS = [
  { id: 'todos',       label: 'Todos' },
  { id: 'verificados', label: 'Verificados' },
  { id: 'elegiveis',   label: 'Elegíveis (Score ≥ 60)' },
];

function BadgeScore({ score }) {
  const cor = score >= 75 ? 'var(--success)'
            : score >= 50 ? '#d97706'
            : 'var(--danger)';
  return (
    <span style={{ fontWeight: '700', color: cor }}>{score ?? 0}</span>
  );
}

export default function FornecedoresConfianca() {
  const [fornecedores, setFornecedores] = useState([]);
  const [filtro,       setFiltro]       = useState('elegiveis');
  const [loading,      setLoading]      = useState(true);
  const [salvando,     setSalvando]     = useState(null);
  const [erro,         setErro]         = useState('');
  const [pesquisa,     setPesquisa]     = useState('');

  useEffect(() => {
    apiFetch('/admin/fornecedores-confianca')
      .then(d => { if (d.sucesso) setFornecedores(d.fornecedores); })
      .catch(e => setErro(e.message))
      .finally(() => setLoading(false));
  }, []);

  const toggleVerificado = async (id, atual) => {
    setSalvando(id);
    try {
      await apiFetch(`/admin/utilizadores/${id}/score-confianca`, 'PATCH', {
        fornecedor_verificado: !atual,
      });
      setFornecedores(prev => prev.map(f =>
        f.id === id ? { ...f, fornecedor_verificado: !atual } : f
      ));
    } catch (e) { setErro(e.message); }
    setSalvando(null);
  };

  const actualizarScore = async (id, score) => {
    setSalvando(id);
    try {
      await apiFetch(`/admin/utilizadores/${id}/score-confianca`, 'PATCH', { score_confianca: score });
      setFornecedores(prev => prev.map(f =>
        f.id === id ? { ...f, score_confianca: score } : f
      ));
    } catch (e) { setErro(e.message); }
    setSalvando(null);
  };

  const filtrados = fornecedores.filter(f => {
    const pesqOk = !pesquisa ||
      f.nome?.toLowerCase().includes(pesquisa.toLowerCase()) ||
      f.email?.toLowerCase().includes(pesquisa.toLowerCase());
    if (!pesqOk) return false;
    if (filtro === 'verificados')  return f.fornecedor_verificado;
    if (filtro === 'elegiveis')    return (f.score_confianca ?? 0) >= 60;
    return true;
  });

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px 16px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '22px', fontWeight: '700', color: 'var(--text-primary)', margin: 0 }}>
          Fornecedores Verificados
        </h1>
        <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '4px' }}>
          Fornecedores verificados têm processo simplificado de publicação.
        </p>
      </div>

      {erro && (
        <div style={{ background: 'var(--danger-bg)', border: '1px solid var(--danger-border)',
          borderRadius: '12px', padding: '12px 16px', marginBottom: '16px',
          color: 'var(--danger)', fontSize: '13px' }}>
          {erro}
        </div>
      )}

      {/* Filtros + Pesquisa */}
      <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          {FILTROS.map(f => (
            <button key={f.id} onClick={() => setFiltro(f.id)}
              style={{
                padding: '8px 16px', borderRadius: '9999px', border: 'none',
                cursor: 'pointer', fontSize: '13px', fontWeight: '600',
                background: filtro === f.id ? 'var(--brand)' : 'var(--card)',
                color:      filtro === f.id ? '#fff' : 'var(--text-secondary)',
                border:     filtro === f.id ? 'none' : '1px solid var(--border)',
              }}>
              {f.label}
            </button>
          ))}
        </div>
        <input
          type="text" placeholder="Pesquisar por nome ou email..."
          value={pesquisa} onChange={e => setPesquisa(e.target.value)}
          style={{
            flex: 1, minWidth: '200px', padding: '8px 12px', borderRadius: '10px',
            border: '1px solid var(--border)', background: 'var(--input-bg)',
            color: 'var(--text-primary)', fontSize: '13px', outline: 'none',
          }}
        />
      </div>

      {loading ? (
        <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '14px' }}>
          A carregar...
        </div>
      ) : (
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)',
          borderRadius: '16px', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
                {['Fornecedor', 'Score', 'Aval.', 'Estado', 'Score manual', 'Acção'].map(h => (
                  <th key={h} style={{ padding: '10px 12px', textAlign: h === 'Fornecedor' ? 'left' : 'center',
                    fontWeight: '600', color: 'var(--text-secondary)', fontSize: '11px',
                    textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.length === 0 && (
                <tr><td colSpan={6} style={{ padding: '40px', textAlign: 'center',
                  color: 'var(--text-secondary)' }}>
                  Nenhum fornecedor encontrado.
                </td></tr>
              )}
              {filtrados.map((f, i) => (
                <tr key={f.id} style={{
                  borderTop: i > 0 ? '1px solid var(--border)' : 'none',
                  opacity: salvando === f.id ? 0.6 : 1,
                }}>
                  {/* Fornecedor */}
                  <td style={{ padding: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div style={{ width: '36px', height: '36px', borderRadius: '50%',
                        background: 'var(--brand-bg)', flexShrink: 0, overflow: 'hidden',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '14px', fontWeight: '700', color: 'var(--brand)' }}>
                        {f.foto_url
                          ? <img src={f.foto_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                          : (f.nome?.[0]?.toUpperCase() || '?')
                        }
                      </div>
                      <div>
                        <p style={{ fontWeight: '600', color: 'var(--text-primary)', margin: 0 }}>{f.nome}</p>
                        <p style={{ fontSize: '11px', color: 'var(--text-secondary)', margin: 0 }}>{f.email}</p>
                      </div>
                    </div>
                  </td>
                  {/* Score */}
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <BadgeScore score={f.score_confianca} />
                  </td>
                  {/* Avaliações */}
                  <td style={{ padding: '12px', textAlign: 'center', color: 'var(--text-secondary)' }}>
                    {f.total_avaliacoes ?? 0}
                  </td>
                  {/* Estado */}
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    {f.fornecedor_verificado ? (
                      <span style={{ fontSize: '11px', fontWeight: '600', padding: '3px 8px',
                        borderRadius: '9999px', background: 'var(--success-bg)', color: 'var(--success)' }}>
                        ✓ Verificado
                      </span>
                    ) : (f.score_confianca ?? 0) >= 75 ? (
                      <span style={{ fontSize: '11px', fontWeight: '600', padding: '3px 8px',
                        borderRadius: '9999px', background: '#fef3c7', color: '#92400e' }}>
                        Elegível
                      </span>
                    ) : (
                      <span style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>Normal</span>
                    )}
                  </td>
                  {/* Score manual */}
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <input
                      type="number" min="0" max="100"
                      defaultValue={f.score_confianca ?? 20}
                      onBlur={e => {
                        const v = parseInt(e.target.value);
                        if (!isNaN(v) && v !== f.score_confianca) actualizarScore(f.id, v);
                      }}
                      style={{
                        width: '60px', textAlign: 'center', fontSize: '13px',
                        border: '1px solid var(--border)', borderRadius: '8px',
                        padding: '4px', background: 'var(--input-bg)', color: 'var(--text-primary)',
                      }}
                    />
                  </td>
                  {/* Acção */}
                  <td style={{ padding: '12px', textAlign: 'center' }}>
                    <button
                      onClick={() => toggleVerificado(f.id, f.fornecedor_verificado)}
                      disabled={salvando === f.id}
                      style={{
                        padding: '6px 14px', borderRadius: '8px', border: 'none',
                        cursor: 'pointer', fontSize: '12px', fontWeight: '600',
                        background: f.fornecedor_verificado ? 'var(--danger-bg)' : 'var(--success-bg)',
                        color:      f.fornecedor_verificado ? 'var(--danger)'    : 'var(--success)',
                      }}>
                      {f.fornecedor_verificado ? 'Remover' : 'Verificar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
